import "./App.css";
import PlayerScreenContainer from "./containers/PlayerScreen/PlayerScreenContainer";

function App() {
  return <PlayerScreenContainer />;
}

export default App;
